export default "__VITE_ASSET__DsjIvBX0__"